import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import "@/styles/Navbar.css";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isActive = (path) => location.pathname === path;

  return (
    <nav className={`navbar ${isScrolled ? "scrolled" : ""}`} data-testid="navbar">
      <div className="container">
        <div className="navbar-content">
          <Link to="/" className="navbar-logo" data-testid="navbar-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_f225f10b-d8b4-4ffa-b240-0898e7a29d8d/artifacts/d1672wh9_LogoBlancoSinfondo-%20website.png" 
              alt="Pimot Construcciones" 
              className="logo-img"
            />
          </Link>

          <div className={`navbar-links ${isMobileMenuOpen ? "mobile-open" : ""}`} data-testid="navbar-links">
            <Link 
              to="/" 
              className={`nav-link ${isActive("/") ? "active" : ""}`}
              data-testid="nav-link-home"
            >
              Inicio
            </Link>
            <Link 
              to="/proyectos" 
              className={`nav-link ${isActive("/proyectos") ? "active" : ""}`}
              data-testid="nav-link-projects"
            >
              Proyectos
            </Link>
            <Link 
              to="/servicios" 
              className={`nav-link ${isActive("/servicios") ? "active" : ""}`}
              data-testid="nav-link-services"
            >
              Servicios
            </Link>
            <Link 
              to="/contacto" 
              className={`nav-link ${isActive("/contacto") ? "active" : ""}`}
              data-testid="nav-link-contact"
            >
              Contacto
            </Link>
          </div>

          <button 
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;